import { css } from '@emotion/css';
// import { cssObj } from '@/css/resources/functions.css';
// import { fontWeights } from '@/css/resources/variables.css';
// import {
// 	grid,
// 	resetFirstLastMargins,
// 	linkUnderline,
// 	gridContentDefault,
// 	gridFull,
// } from '@/css/resources/placeholders.css';
// import {
// 	fontStyle,
// 	fluidPadding,
// 	fluidValues,
// 	fluidMargin,
// } from '@/css/resources/mixins.css';

const getStyles = () => css({});

const getHeaderStyles = () =>
	css({
		'.supt-figure': {
			flexDirection: 'column',
			alignItems: 'flex-start',

			span: {
				aspectRatio: '1/1',
			},

			'> span > img': {
				objectFit: 'cover',
			},

			'.supt-figure__figcaption': {
				display: 'block !important',
			},
		},
	});

export { getStyles, getHeaderStyles };
